import React from "react";
import { Link } from "react-router-dom";

const BigDealOne = () => {
  const tools = [
    {
      image: "assets/images/thumbs/pliers.png",
      name: "PLIERS",
    },
    {
      image: "assets/images/thumbs/hammer.png",
      name: "HAMMER",
    },
    {
      image: "assets/images/thumbs/wrench.png",
      name: "WRENCH",
    },
    {
      image: "assets/images/thumbs/screwdriver.png",
      name: "SCREWDRIVER",
    },
    {
      image: "assets/images/thumbs/allen-keys.png",
      name: "ALLEN KEYS",
    },
    {
      image: "assets/images/thumbs/spirit-level.png",
      name: "SPIRIT LEVEL",
    },
  ];

  return (
    <section className="tools-showcase-section">
      <div className="container container-lg">
        <div className="tools-showcase-wrapper">
          {/* Background */}
          <img
            src="assets/images/bg/big-deal-pattern.png"
            alt=""
            className="tools-showcase-bg"
          />

          {/* Heading */}
          <div className="tools-showcase-header">
            <h4 className="tools-showcase-title">Hand Tools and Equipment</h4>
          </div>

          {/* Tool Grid */}
          <div className="tools-showcase-grid">
            {tools.map((tool, index) => (
              <div className="tools-showcase-item" key={index}>
                <div className="tools-showcase-image-wrap">
                  <img
                    src={tool.image}
                    alt={tool.name}
                    className="tools-showcase-image"
                  />
                </div>

                <p className="tools-showcase-name">{tool.name}</p>
              </div>
            ))}
          </div>

          {/* Button */}
          <div className="tools-showcase-button-wrap">
            <Link to="/hand-tools-equipment" className="tools-showcase-button">
              Shop Now
              <i className="ph ph-shopping-cart" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BigDealOne;
